import React from "react";
import AboutUsDetails from "../components/AboutUsDetails";
import Background from '../images/desk2.jpg';
import "../styles/cover.css"
import "../styles/main.css"

export default class AboutUs extends React.Component {
    render() {
        return (
            <div className="outer-container-cover">
                <div className="container-my-cover">
                    <div className="padding-bottom">

                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-6 col-lg-6 no-padding-right">
                                <AboutUsDetails/>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6 no-padding-left">
                            <img src={Background} className="info-image"/>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}